export enum CommentStatus {
  UNSEEN = 0,
  SEEN = 1,
  REPLIED = 2,
  NOT_REPLIED = 3,
}
